module.exports = __webpack_public_path__ + "img/2.a375b6ec.png";